<!-- Filter dialog button template -->
<div class="relative inline-block">
  <!-- Filter Dialog Button -->
  <button
    class="flex h-10 items-center gap-3 rounded-full border px-5 py-2 transition-colors duration-300"
    [class]="
      isDialogClosed && !active()
        ? 'border-neutral-800 bg-white text-neutral-800 hover:bg-neutral-50'
        : 'border-neutral-900 bg-neutral-900 text-white'
    "
    [attr.aria-controls]="filterName() + 'Dialog'"
    (click)="toggleDialog()"
    type="button"
  >
    <span class="text-base leading-normal font-normal">{{
      filterName() | translate
    }}</span>
    <!-- Plus icon when dialog is closed, minus icon when dialog is open -->
    <svg
      class="h-4 w-4"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      @if (isDialogClosed) {
        <path
          d="M8 3V13M3 8H13"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      } @else {
        <path
          d="M3 8H13"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      }
    </svg>
  </button>

  <!-- Filter Dialog -->
  <div
    class="shadow-lg filter-dialog-container absolute top-full left-0 z-[100] mt-2 h-[390px] max-h-[390px] w-[320px] max-w-[320px] overflow-hidden rounded-lg border border-neutral-800 bg-white"
    [id]="filterName() + 'Dialog'"
    [attr.aria-label]="filterName() + ' selection dialog'"
    [hidden]="isDialogClosed"
    (click)="$event.stopPropagation()"
    (keydown.escape)="closeDialog()"
    role="dialog"
  >
    <ng-content />
  </div>
</div>
